export const snowfallStorageKey = 'sip-snowfall-level';
export const snowPileStorageKey = 'sip-snow-pile-enabled';
